import { Language } from './_autogenerated_';

export const DEFAULT_LANGUAGE = Language.NL;
export const FALLBACK_LANGUAGE = Language.NL;
